import { memo } from 'react';

import LinkIconSVG from '@/assets/link-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ILinkIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={LinkIconSVG} {...props} />;

export const LinkIcon = memo(ILinkIcon) as typeof ILinkIcon;
